<template>
  <div id="contenedor-editar-propuesta">
    <v-form v-model="formularioValido" ref="editarAperturaPropuesta">
      <v-card>
        <v-card-title class="secondary--text">
          Editar Propuesta del Participante
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Participante"
            v-model="nombreParticipante"
            readonly
          >
          </custom-text-field>
          <v-row justify="center">
            <v-col cols="12" md="3">
              <v-switch
                label="¿Asistió?"
                v-model="licitacionAperturaPropuesta.asistio"
                inset
              >
              </v-switch>
            </v-col>
            <v-col cols="12" md="3">
              <v-switch
                label="¿Completa?"
                v-model="licitacionAperturaPropuesta.completa"
                inset
              >
              </v-switch>
            </v-col>
            <v-col cols="12" md="3">
              <v-switch
                label="¿Aceptada para Revisión?"
                v-model="licitacionAperturaPropuesta.aceptadaRevision"
                inset
              >
              </v-switch>
            </v-col>
            <v-col cols="12" md="3">
              <v-switch
                label="¿Pasó Revisión?"
                v-model="licitacionAperturaPropuesta.pasoRevision"
                inset
              >
              </v-switch>
            </v-col>
          </v-row>
          <custom-text-area
            cols="12"
            md="12"
            v-model="licitacionAperturaPropuesta.observaciones"
            label="Observaciones"
            auto-grow
            required
          >
          </custom-text-area>
          <v-row
          v-if="participanteLicitacion.aperturaPropuestas.obras.length > 0">
            <v-col cols="12" md="8">
              <v-row v-for="(obra, index) in participanteLicitacion.aperturaPropuestas.obras"
              :key="index">
                <custom-text-field
                  class="mb-0 pb-0"
                  cols="12"
                  md="6"
                  label="Clave de Obra"
                  :value="obra.obra.clave"
                  disabled
                >
                </custom-text-field>
                <custom-text-field
                  v-model.number="obra.importe"
                  prefix="$"
                  es-dinero
                  cols="12"
                  md="6"
                  label="Importe"
                >
                </custom-text-field>
                <custom-text-area
                  cols="12"
                  md="12"
                  label="Meta de la Obra"
                  :value="obra.obra.meta"
                  disabled
                >
                </custom-text-area>
              </v-row>
            </v-col>
            <v-col cols="12" md="4">
              <v-row>
                <custom-text-field
                  class="mx-0 px-0"
                  cols="12"
                  label="Importe Total"
                  prefix="$"
                  es-dinero
                  :value="importeTotal"
                  readonly
                >
                </custom-text-field>
                <custom-text-field
                  class="mx-0 px-0"
                  cols="12"
                  label=" % IVA"
                  prefix="%"
                  type="number"
                  v-model="tasaIva"
                >
                </custom-text-field>
                <custom-text-field
                  class="mx-0 px-0"
                  cols="12"
                  label="Importe IVA"
                  prefix="$"
                  es-dinero
                  :value="ivaTotal"
                  readonly
                >
                </custom-text-field>
                <custom-text-field-green
                  class="mx-0 px-0"
                  cols="12"
                  label=" Total"
                  prefix="$"
                  es-dinero
                  :value="total"
                  readonly
                >
                </custom-text-field-green>
              </v-row>
            </v-col>
          </v-row>
          <v-row
          v-else>
            <custom-text-field
              v-model.number="licitacionAperturaPropuesta.importe"
              class="mx-0 px-1"
              cols="12"
              md="3"
              label="Importe Total"
              prefix="$"
              es-dinero
            >
            </custom-text-field>
            <custom-text-field
              class="mx-0 px-1"
              cols="12"
              md="3"
              label=" % IVA"
              prefix="%"
              type="number"
              v-model="tasaIva"
            >
            </custom-text-field>
            <custom-text-field
              class="mx-0 px-1"
              cols="12"
              md="3"
              label="Importe IVA"
              prefix="$"
              es-dinero
              :value="ivaTotal"
              readonly
            >
            </custom-text-field>
            <custom-text-field-green
              class="mx-0 px-1"
              cols="12"
              md="3"
              label=" Total"
              prefix="$"
              es-dinero
              :value="total"
              readonly
            >
            </custom-text-field-green>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="actualizar"
            tipo="formAceptar"
            label="Actualizar"
            :disabled="!formularioValido || enviandoFormulario"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import mixLicitacionesAperturaPropuestas from './mixLicitacionesAperturaPropuestas';

export default {
  name: 'LicitacionEditarAperturaPropuesta',
  mixins: [mixLicitacionesAperturaPropuestas],
  props: {
    participanteLicitacion: Object,
  },
  components: {
    CustomTextField,
    CustomTextArea,
    CustomButton,
    CustomTextFieldGreen,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      nombreParticipante: this.participanteLicitacion.contratista.nombreRazonSocial,
      totalImporte: 0,
      // tasaIva: this.participanteLicitacion.aperturaPropuestas.obras[0].porcentajeIva,
      tasaIva: this.participanteLicitacion.aperturaPropuestas.porcentajeIva || 16,
      licitacionAperturaPropuesta: {
        asistio: this.participanteLicitacion.aperturaPropuestas.asistio,
        completa: this.participanteLicitacion.aperturaPropuestas.completa,
        importe: this.participanteLicitacion.aperturaPropuestas.importe,
        porcentajeIva: this.participanteLicitacion.aperturaPropuestas.porcentajeIva || 16,
        importeIva: this.participanteLicitacion.aperturaPropuestas.importeIva,
        total: this.participanteLicitacion.aperturaPropuestas.total,
        aceptadaRevision: this.participanteLicitacion.aperturaPropuestas.aceptadaRevision,
        pasoRevision: this.participanteLicitacion.aperturaPropuestas.pasoRevision,
        observaciones: this.participanteLicitacion.aperturaPropuestas.observaciones,
        obras: this.participanteLicitacion.aperturaPropuestas.obras,
      },
      propuestasObras: [],
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    actualizar() {
      const ivaTasa = this.tasaIva * 0.01;
      this.licitacionAperturaPropuesta.obras = this.licitacionAperturaPropuesta.obras.map(
        ({
          id, idParticipante, idObra, idUsuarioCreo, importe,
        }) => ({
          id,
          idParticipante,
          idObra,
          idUsuarioCreo,
          importe,
          porcentajeIva: parseFloat(this.tasaIva),
          iva: this.$numberRound(importe * ivaTasa),
          total: this.$numberRound(importe + (importe * ivaTasa)),
        }),
      );
      this.licitacionAperturaPropuesta.importe = this.importeTotal;
      this.licitacionAperturaPropuesta.porcentajeIva = parseFloat(this.tasaIva);
      this.licitacionAperturaPropuesta.importeIva = this.ivaTotal;
      this.licitacionAperturaPropuesta.total = this.total;
      this.mixActualizarLicitacionAperturaPropuesta();
    },
  },
  computed: {
    importeTotal() {
      if (!this.participanteLicitacion.aperturaPropuestas.obras.length > 0) {
        return this.licitacionAperturaPropuesta.importe;
      }
      return this.$ObjSumar(this.licitacionAperturaPropuesta.obras, 'importe');
    },
    ivaTotal() {
      const ivaTasa = this.tasaIva * 0.01;
      return this.$numberRound(this.importeTotal * ivaTasa);
    },
    total() {
      if (!this.importeTotal || !this.ivaTotal) return 0;
      return this.$numberRound(this.importeTotal + this.ivaTotal);
    },
  },
};
</script>

<style>
</style>
